import { Popper, autocompleteClasses, outlinedInputClasses } from '@mui/material'
import { CHIP_CLASS_NAME } from '../Chip/classnames'
import { styled } from '../../utils/styled'
import Typography from '../Typography'
import { StyledInput } from '../Input/styles'

export const StyledPopper = styled(Popper)(({ theme }) => ({
  width: 'fit-content',
  zIndex: theme.zIndex.dropdown,
  [`& .${autocompleteClasses.paper}`]: {
    color: 'inherit',
    borderRadius: theme.borderRadius.xxLarge,
    boxShadow: theme.elevation.mediumDepth,
    height: '100%',
    maxHeight: 'calc((95vh / 2) - 40px)',
    padding: '24px 12px',
    overflowY: 'auto'
  },
  [`& .${autocompleteClasses.loading}`]: {
    ...theme.typography.body2,
    color: theme.tokens.foreground.main.primary,
    padding: '16px 24px'
  }
}))

export const StyledTypographyNoOptionsText = styled(Typography)(({ theme }) => ({
  color: theme.tokens.foreground.main.disabled,
  padding: '12px 12px 8px 12px'
}))

export const StyledInputAutocompleteTextField = styled(StyledInput)<{ color?: 'error' | 'success' }>(
  ({ theme, color }) => ({
    [`.${autocompleteClasses.inputRoot}.${outlinedInputClasses.root}`]: {
      [`&:has(.${CHIP_CLASS_NAME})`]: {
        backgroundColor: theme.tokens.background.main.default,
        paddingLeft: '4px',
        paddingTop: '4px',
        paddingBottom: '4px',
        rowGap: '8px',
        columnGap: '4px',
        [`.${autocompleteClasses.input}`]: {
          padding: '4px'
        }
      },
      paddingLeft: '8px',
      padding: '8px 16px',
      [`.${autocompleteClasses.input}`]: {
        padding: '0px',
        paddingLeft: '4px'
      },
      [`.${CHIP_CLASS_NAME}`]: {
        margin: '0px',
        maxWidth: '100%'
      },
      ...(color !== undefined
        ? {
            borderColor: color,
            '& .MuiOutlinedInput-root': {
              '&.Mui-focused fieldset': {
                borderColor: color
              }
            }
          }
        : {})
    }
  })
)
